import React, { useRef, useState } from 'react';
import './Login.css';
import { AuthenticationProvider } from '../../Services/AuthenticationProvider';
import { Button, Form, Input, Checkbox, Card, Alert } from 'antd';

const ERROR_COPY = {
  credentials: 'Username or password is incorrect.',
  network: "Can't reach the server — check your connection and try again.",
};

export default function Login() {
  const [submitting, setSubmitting] = useState(false);
  const [errorReason, setErrorReason] = useState(null);
  // Enter inside a field fires the native form submit, which antd Button
  // `loading` does not guard — a ref blocks re-entry synchronously.
  const inFlight = useRef(false);

  async function onFinish(values) {
    if (inFlight.current) return;
    inFlight.current = true;
    setSubmitting(true);
    setErrorReason(null);
    const result = await AuthenticationProvider.login(
      values.username,
      values.password,
      values.remember,
    );
    if (result.ok) {
      // Stay locked until the reload lands.
      window.location.reload();
      return;
    }
    inFlight.current = false;
    setErrorReason(result.reason);
    setSubmitting(false);
  }

  return (
    <div className="Login">
      <Card className="login-card">
        <h1 className="login-title">Sprinkler Commander</h1>
        <Form
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input autoComplete="username" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          {errorReason && (
            <Form.Item>
              <Alert
                data-testid="login-error"
                type="error"
                showIcon
                message={ERROR_COPY[errorReason] || ERROR_COPY.network}
              />
            </Form.Item>
          )}
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              block
              loading={submitting}
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
